<template>
  <div>
    <nav class="toolbox toolbox-pagination" v-if="showPagination">
      <div class="toolbox-item toolbox-show">
        <label>{{ paginationResultsTitle }}</label>
      </div>
      <!-- End .toolbox-item -->
      <ul class="pagination">
        <li class="page-item" :class="{ disabled: prevDisabled }">
          <router-link
            class="page-link prev"
            :to="{ query: { page: 1, search: $route.query.search, ...paginationProps } }"
          >
            <span>
              <i class="icon-angle-double-left" />
            </span>
          </router-link>
        </li>
        <li class="page-item" :class="{ disabled: prevDisabled }">
          <router-link
            class="page-link prev"
            :to="{
              query: {
                page: +currentRoute.query.page - 1,
                search: $route.query.search,
                ...paginationProps,
              },
            }"
          >
            <span>
              <i class="icon-angle-left"></i>
            </span>
          </router-link>
        </li>
        <li
          class="page-item"
          :class="{
            active: index == currentRoute.query.page || (index === 1 && !currentRoute.query.page),
          }"
          v-for="index in pages"
          :key="index"
        >
          <router-link
            exact
            class="page-link"
            :to="{ query: { page: index, search: $route.query.search, ...paginationProps } }"
          >
            {{ index }}
          </router-link>
        </li>

        <li class="page-item" :class="{ disabled: nextDisabled }">
          <router-link
            class="page-link next"
            :to="{
              query: {
                page: parseInt(currentRoute.query.page || 1, 10) + 1,
                search: $route.query.search,
                ...paginationProps,
              },
            }"
          >
            <span>
              <a class="page-link page-link-btn" href="#"><i class="icon-angle-right"></i></a>
            </span>
          </router-link>
        </li>

        <li class="page-item" :class="{ disabled: nextDisabled }">
          <router-link
            class="page-link next"
            :to="{
              query: { page: pager.totalPages, search: $route.query.search, ...paginationProps },
            }"
          >
            <span>
              <i class="icon-angle-double-right" />
            </span>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { pager, translations } from '@/mixins';

export default {
  name: 'Pagination',
  mixins: [pager, translations],
  data() {
    return {
      actionName: this.action,
    };
  },
  computed: {
    currentRoute() {
      return this.$route;
    },
  },
  props: {
    action: String,
    paginationProps: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    const { query } = this.$route;

    const timerId = setTimeout(() => {
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
        page: query?.page ? parseInt(query.page, 10) : 1,
      });
      clearTimeout(timerId);
    }, 0);
  },
  watch: {
    '$route.query.page': function redirect(page = 1) {
      this.goToPage(parseInt(page, 10));
    },
  },
};
</script>

<style lang="scss" scoped>
.page-item:not(.disabled) {
  cursor: pointer;
}

.page-item.disabled {
  cursor: not-allowed;
}
</style>
